
import React from "react";
import ProjectTemplate from "../components/ProjectTemplate";

const CreaxPage = () => {
  const media = 
  [
    '/images/metabolomics.webp',
    '/images/flowmechanics.webp', 
    '/images/lumina.webp',
    '/images/comunicat.webp', 
    '/images/curious.webp',
    '/images/creature.webp'
  ];

  return (
    <div className="creax-page">
      <ProjectTemplate
        title="creax"
        year="2015-2020"
        sections={[
          {
            type: "description",
            text: 'Creax was a musical journey, birthed from classical piano and dub. These early tunes were increasingly recycled in subsequent music with sample based splicing techniques.  But it was time to move on from that, recycling of the same material can not happen indefinately. Flow Mechanics cover is designed by Aliz Soos',
          },
 
          {
            type: "image",
            links: [
              {
                src: media[0],
                href: 'https://open.spotify.com/album/1M9C3z8ey3wW5zQhlcbzCC?si=lZ8jaMYES0KUXCJ39mibVA',
                text: 'metabolomics',
                year: '2020'
              },
              {
                src: media[1],
                href: 'https://open.spotify.com/album/7DsyFmwWTfsPugrZrUUcll?si=lRQGSpoiSzGwsLGsmJUjCA',
                text: 'flow mechanics',
                year: '2019'
              },
              {
                src: media[2], 
                href:'https://soundcloud.com/squarehunter/sets/lumina',
                text: 'lumina',
                year: '2018'
              },
              {
                src: media[3],
                href: 'https://open.spotify.com/album/7J5uLTZIdbfW26azj2T7gX?si=yxRXoqWdRJmlmXZWk-4l1A',
                text: 'comunicat',
                year: '2017' 
              }, 
              {
                src: media[4],
                href: 'https://soundcloud.com/squarehunter/sets/curious',
                text: 'curious',
                year: '2016' 
              }, 
              {
                src: media[5],
                href: 'https://soundcloud.com/squarehunter/sets/budapest-sounds',
                text: 'creature',
                year: '2015' 
              }, 


            ],
            isLink: true,
          },
          // {
          //   type: "description",
          //   text: 'I also use ZINK as the main project to produce music at Showsync'
          // },
          // {
          //   type: 'video',
          //   links: ['https://www.youtube.com/embed/hkhn08ebyRw?si=AssNnX9agddG5U2W']
          // }
        ]}
      />
    </div>
  );
};

export default CreaxPage;
